module.exports = __webpack_public_path__ + "img/7-text.cd5f541b.png";